<template>
   <div>

       <div class="search-bar">
           <el-input
                   size="small"
                   v-model="searchParams.keyword"
                   placeholder="输入关键字进行过滤"
                   style="margin-bottom: 10px;"
           ></el-input>
       </div>

       <el-table
               :data="tableData"
               max-height="500"
               style="width: 100%">
           <el-table-column
                   prop="name"
                   label="权限名称"
                   >
           </el-table-column>

           <el-table-column
                   prop="flag"
                   label="权限标识"
                   >
           </el-table-column>

           <el-table-column
                   fixed="right"
                   label="操作"
                   width="100">
               <template slot-scope="scope">
                   <el-switch v-model="scope.row.chosen" @change="handleChange(scope.row)"></el-switch>
               </template>
           </el-table-column>

       </el-table>
   </div>
</template>

<script>
    export default {
        name: "RuleTable",
        props:{
           moduleCode:{
               type:String,
               default:''
           },chosenRules:{
               type:Array,
               default:function () {
                   return [] ;
               }
           },
        },
        watch:{

            moduleCode(v){
                this.searchParams.moduleCode = v;
            },
            searchParams:{
               deep:true,
                handler:function () {
                    this.loadRules();
                }
            },
            chosenRules(){
                let vm = this;
                this.tableData.forEach((rule)=>{
                    rule.chosen = (vm.chosenRules.filter((r)=>{ return rule.code === r.code}).length > 0)
                });
            },
        },
        data() {
            return {
                tableData: [],
                searchParams:{
                    keyword:'',
                    moduleCode:'',
                    onPage:false
                }
            }
        },
        methods:{
            handleChange(e){
                this.$emit('handleRuleChange',e);
            },
           loadRules(){

               let vm = this;
               vm.$http.post(vm.$api.rule.list,this.searchParams).then((resp)=>{

                   resp.data.data.rules.forEach((rule)=>{
                       rule.chosen = (vm.chosenRules.filter((r)=>{ return rule.code === r.code}).length > 0)
                   });

                   vm.tableData = resp.data.data.rules;

               });

           }
        },
        created() {
            this.loadRules();
        }
    }
</script>

<style scoped>

</style>